import { SystemModulesEnum } from '@models/module/main/systemModules.enum';
import { ModuleModel } from '@module-instance/modules/common';

export enum ModuleConfigTab {
  Details,
  Permissions,
  Relations,
  StartScreens,
  Presets,
  TransitionGroups,
  Signatures,
  Workflow,
  Forms,
  Printouts,
  Notifications,
  Views,
}

export const MODULE_CONFIG_TABS = [
  ModuleConfigTab.Details,
  ModuleConfigTab.Permissions,
  ModuleConfigTab.Relations,
  ModuleConfigTab.StartScreens,
  ModuleConfigTab.Presets,
  ModuleConfigTab.TransitionGroups,
  ModuleConfigTab.Signatures,
  ModuleConfigTab.Workflow,
  ModuleConfigTab.Forms,
  ModuleConfigTab.Printouts,
  ModuleConfigTab.Notifications,
  ModuleConfigTab.Views,
];

export const MODULE_CONFIG_TAB_LABELS: Record<ModuleConfigTab, string> = {
  [ModuleConfigTab.Details]: 'modules.tabs.details',
  [ModuleConfigTab.Permissions]: 'modules.tabs.permissions',
  [ModuleConfigTab.Relations]: 'modules.tabs.relations',
  [ModuleConfigTab.StartScreens]: 'modules.tabs.startScreens',
  [ModuleConfigTab.Presets]: 'modules.tabs.presets',
  [ModuleConfigTab.TransitionGroups]: 'modules.tabs.transitionGroups',
  [ModuleConfigTab.Signatures]: 'modules.tabs.signatures',
  [ModuleConfigTab.Workflow]: 'modules.tabs.workflow',
  [ModuleConfigTab.Forms]: 'modules.tabs.forms',
  [ModuleConfigTab.Printouts]: 'modules.tabs.printouts',
  [ModuleConfigTab.Notifications]: 'modules.tabs.notifications',
  [ModuleConfigTab.Views]: 'modules.tabs.views',
};

export const MODULE_CONFIG_TAB_TEST_IDS: Record<ModuleConfigTab, string> = {
  [ModuleConfigTab.Details]: 'module-config-tab-details',
  [ModuleConfigTab.Permissions]: 'module-config-tab-permissions',
  [ModuleConfigTab.Relations]: 'module-config-tab-relations',
  [ModuleConfigTab.StartScreens]: 'module-config-tab-start-screens',
  [ModuleConfigTab.Presets]: 'module-config-tab-presets',
  [ModuleConfigTab.TransitionGroups]: 'module-config-tab-transition-groups',
  [ModuleConfigTab.Signatures]: 'module-config-tab-signatures',
  [ModuleConfigTab.Workflow]: 'module-config-tab-workflow',
  [ModuleConfigTab.Forms]: 'module-config-tab-forms',
  [ModuleConfigTab.Printouts]: 'module-config-tab-printouts',
  [ModuleConfigTab.Notifications]: 'module-config-tab-notifications',
  [ModuleConfigTab.Views]: 'module-config-tab-views',
};

export const visibleModuleConfigTabs = (module: ModuleModel, isNew: boolean): ModuleConfigTab[] => {
  if (isNew || !module) {
    return [ModuleConfigTab.Details];
  }
  const isSovItems = module.id === SystemModulesEnum.SOVI;
  const visible: Record<ModuleConfigTab, boolean> = {
    [ModuleConfigTab.Details]: true,
    [ModuleConfigTab.Permissions]: !isSovItems,
    [ModuleConfigTab.Relations]: !!module.hasRelations,
    [ModuleConfigTab.StartScreens]: !!module.hasFields,
    [ModuleConfigTab.Presets]: !!module.hasPresets,
    [ModuleConfigTab.TransitionGroups]: !!module.hasWorkflow,
    [ModuleConfigTab.Signatures]: !!module.hasWorkflow,
    [ModuleConfigTab.Workflow]: !!module.hasWorkflow,
    [ModuleConfigTab.Forms]: !!module.hasWorkflow,
    [ModuleConfigTab.Printouts]: !!module.hasTemplates && module.id === SystemModulesEnum.Correspondence,
    [ModuleConfigTab.Notifications]: !!module.hasWorkflow,
    [ModuleConfigTab.Views]: !!module.hasFields || !!module.hasWorkflow || isSovItems,
  };
  return MODULE_CONFIG_TABS.filter(tab => visible[tab]);
};

export const moduleConfigTabLabel = (tab: ModuleConfigTab, moduleId: number): string =>
  tab === ModuleConfigTab.StartScreens && moduleId === SystemModulesEnum.SOVI
    ? 'modules.tabs.startScreen'
    : MODULE_CONFIG_TAB_LABELS[tab];

export interface ModuleConfigDialogTarget {
  moduleId?: number;
  name?: string;
  iconId?: number;
}

export interface ModuleConfigDialogData extends ModuleConfigDialogTarget {
  isConfig?: boolean;
}

export interface ModuleConfigDialogResult {
  moduleChanged: boolean;
  reloadGrid: boolean;
  reloadModuleInformation: boolean;
  moduleId: number;
  name: string;
  abbreviation: string;
  iconId: number;
  duplicate: boolean;
}
